export default {

  data () {
    return {
    /*******************************************************************************************************
     * FG - FOOF - After Cert - First Release Security (7)
     * Variables below were put in place when security was added in Feb/March 2021
     * They are used by the functions in this file that decide what should / should not be displayed in the
     * menu.
     *******************************************************************************************************/
      DashboardChoiceDependsOn:       ['incidents','chemicalrecord','activity'], 
      ComplianceChoiceDependsOn:      ['safetyplanmanagement','compliancedoc','MAHCchecklist','MAHCwebsite','MAHCsearch'],
      HealthAndSafetyChoiceDependsOn: ['chemicalrecord','maintenance','incidents'],
      AdministrationChoiceDependsOn:  ['inventory','suppliers','stafftraining','activity'],
      //FG - FOOF - After Cert - First Release Security - custom readings controlled by "managetemplates"
      //SettingsChoiceDependsOn:        ['security','managefacility','managevenue','facilityscheduling','positions','certificates','evaluations','managetemplates','managecustomreadings','managecustomtasks','managecustommaintenance'],
      SettingsChoiceDependsOn:        ['security','managefacility','managevenue','facilityscheduling','positions','certificates','evaluations','managetemplates'],
      //FG - FOOF - After Cert - First Release Security - custom readings controlled by "managetemplates"
      //TemplatesChoiceDependsOn:       ['managetemplates','managecustomreadings','managecustomtasks','managecustommaintenance'],
      TemplatesChoiceDependsOn:       ['managetemplates'],
      /*******************************************************************************************************
      * FG - FOOF - After Cert - First Release Security (7)
      *******************************************************************************************************/

      stateName: '',
      currentRole: '',
      locations: [],
      value: '',
      currentUser:'',
      dropStyle: {
        display: 'none'
      },
      templateStyle :{
        background: '#344240'
      }
    }
  },
  mounted () {
    window.globallocid = ''

    this.stateName = this.$route.name
    this.currentRole = window.authDetails ? window.authDetails.role : ''
    this.currentUser =  window.authDetails ? window.authDetails.userName : ''

    if (this.stateName != 'login' && this.stateName != 'resetpassword' && this.stateName != 'signup' && this.stateName != 'signupconfirm') {
      //this.getLocations()
      //this.getpools(0)
    }



  },
  watch: {
    '$route' (to, from) {
      this.stateName = to.name
      this.currentRole = window.authDetails ? window.authDetails.role : ''
      this.currentUser =  window.authDetails ? window.authDetails.userName : ''
    },
    value: function (val) {

      this.pools = []
      this.poolid = ''
      this.getpools(val)
      this.$router.app.$emit('emittedlocation', JSON.stringify(val))
      window.globallocid = val

    }
  },
  methods: {
    /*******************************************************************************************************
     * FG - FOOF - After Cert - First Release Security (7)
     * Methods below were put in place when security was added in Feb/March 2021
     * They are used by the navigation_bar.vue file to decide what menu choices are/are not displayed
     *******************************************************************************************************/
    //
    //Dashboard
    displayDashboardChoice:     function() {return this.$hydrowareSecurityJS.canDisplay_A(this.DashboardChoiceDependsOn)},
    
    //Compliance
    displayComplianceChoice:    function() {return this.$hydrowareSecurityJS.canDisplay_A(this.ComplianceChoiceDependsOn)},
    displaySafetyPlanChoice:    function() {return this.$hydrowareSecurityJS.canDisplay_A('safetyplanmanagement');},
    displayComplianceDocChoice: function() {return this.$hydrowareSecurityJS.canDisplay_A('compliancedoc');},
    displayMAHCChecklistChoice: function() {return this.$hydrowareSecurityJS.canDisplay_A('MAHCchecklist');},
    displayMAHCWebsiteChoice:   function() {return this.$hydrowareSecurityJS.canDisplay_A('MAHCwebsite');},
    displayMAHCSearchChoice:    function() {return this.$hydrowareSecurityJS.canDisplay_A('MAHCsearch');},

    //Risk Management
    displayRiskManagementChoice: function(){return this.$hydrowareSecurityJS.canDisplay_A('potentialhazard');},
    displayPotentialHazardChoice:function(){return this.$hydrowareSecurityJS.canDisplay_A('potentialhazard');},

    //Health & Safety
    displayHealthAndSafetyChoice:function() {return this.$hydrowareSecurityJS.canDisplay_A(this.HealthAndSafetyChoiceDependsOn)},
    displayReadingsAndTasks:     function() {return this.$hydrowareSecurityJS.canDisplay_A('chemicalrecord');},
    displayMaintenance:          function() {
      return this.$hydrowareSecurityJS.canDisplay_A('maintenance');
    },
    displayIncidents:            function() {return this.$hydrowareSecurityJS.canDisplay_A('incidents');},

    //Personnel
    displayPersonnelChoice: function() {return this.$hydrowareSecurityJS.canDisplay_A('personnel');},
    displayProfileChoice:   function() {return this.$hydrowareSecurityJS.canDisplay_A('personnel');},

    //Patrons
    // -- ALL OF THE CHOICES UNDER THIS CHOICE ARE UNDER CONSTRUCTION

    //Administration
    displayAdministrationChoice: function() {return this.$hydrowareSecurityJS.canDisplay_A(this.AdministrationChoiceDependsOn)},
    displayInventoryChoice:      function() {return this.$hydrowareSecurityJS.canDisplay_A('inventory');},
    displaySuppliersChoice:      function() {return this.$hydrowareSecurityJS.canDisplay_A('suppliers');},
    displayStaffTrainingChoice:  function() {return this.$hydrowareSecurityJS.canDisplay_A('stafftraining');},
    displayActivitiesChoice:     function() {return this.$hydrowareSecurityJS.canDisplay_A('activity');},

    displaySettingsChoice:                  function() {return this.$hydrowareSecurityJS.canDisplay_A(this.SettingsChoiceDependsOn);},
    displaySecurityChoice:                  function() {return this.$hydrowareSecurityJS.canDisplay_A('security');},
    displayManageFacilityChoice:            function() {return this.$hydrowareSecurityJS.canDisplay_A('managefacility');},
    displayManageVenueChoice:               function() {return this.$hydrowareSecurityJS.canDisplay_A('managevenue');},
    displayFacilitySchedulingChoice:        function() {return this.$hydrowareSecurityJS.canDisplay_A('facilityscheduling');},
    displayPositionsChoice:                 function() {return this.$hydrowareSecurityJS.canDisplay_A('positions');},
    displayCertificatesChoice:              function() {return this.$hydrowareSecurityJS.canDisplay_A('certificates');},           
    displayEvaluationsChoice:               function() {return this.$hydrowareSecurityJS.canDisplay_A('evaluations');},           
    displayTemplatesChoice:                 function() {return this.$hydrowareSecurityJS.canDisplay_A(this.TemplatesChoiceDependsOn);},
    displayManageTemplatesChoice:           function() {return this.$hydrowareSecurityJS.canDisplay_A('managetemplates');},  
    //FG - FOOF - After Cert - First Release Security - custom settings are controlled by "managetemplates" for the first release
    //displayManageCustomReadingsChoice:      function() {return this.$hydrowareSecurityJS.canDisplay_A('managecustomreadings');},  
    //displayManageCustomTasksChoice:         function() {return this.$hydrowareSecurityJS.canDisplay_A('managecustomtasks');},  
    //displayManageCustomMaintenanceChoice:   function() {return this.$hydrowareSecurityJS.canDisplay_A('managecustommaintenance');}, 
    displayManageCustomReadingsChoice:      function() {return this.$hydrowareSecurityJS.canDisplay_A('managetemplates');},  
    displayManageCustomTasksChoice:         function() {return this.$hydrowareSecurityJS.canDisplay_A('managetemplates');},  
    displayManageCustomMaintenanceChoice:   function() {return this.$hydrowareSecurityJS.canDisplay_A('managetemplates');},  
    /*******************************************************************************************************
     * FG - FOOF - After Cert - First Release Security (7) - Above
    (*******************************************************************************************************/

    templateDropdown : function(e){
      e.stopPropagation();
      e.preventDefault();
      if(this.dropStyle.display == 'none'){
        this.dropStyle.display = 'block';
        this.templateStyle.background ='#797979';
      } 
      else{
        this.dropStyle.display = 'none';
        this.templateStyle.background = '#344240'; 
      }
    },
    hideDropdown : function(){
      this.dropStyle.display = 'none';
      this.templateStyle.background = '#344240';
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/NavigationBar/navigation_bar.controller.js